/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { PhoneDetails } from './PhoneDetails';
import {
  PhoneDetailsFromJSON,
  PhoneDetailsFromJSONTyped,
  PhoneDetailsToJSON,
} from './PhoneDetails';
import type { EmailDetails } from './EmailDetails';
import {
  EmailDetailsFromJSON,
  EmailDetailsFromJSONTyped,
  EmailDetailsToJSON,
} from './EmailDetails';
import type { Address } from './Address';
import {
  AddressFromJSON,
  AddressFromJSONTyped,
  AddressToJSON,
} from './Address';

/**
 *
 * @export
 * @interface LeadPost
 */
export interface LeadPost {
  /**
   * List of addresses
   * @type {Array<Address>}
   * @memberof LeadPost
   */
  addresses?: Array<Address>;
  /**
   * Optionally assign the Lead to a Campaign
   * @type {string}
   * @memberof LeadPost
   */
  campaignId?: string;
  /**
   *
   * @type {object}
   * @memberof LeadPost
   */
  custom?: object;
  /**
   *
   * @type {string | null}
   * @memberof LeadPost
   */
  department?: string | null;
  /**
   * List of email details
   * @type {Array<EmailDetails>}
   * @memberof LeadPost
   */
  emails?: Array<EmailDetails>;
  /**
   *
   * @type {number | null}
   * @memberof LeadPost
   */
  engagementScore?: number | null;
  /**
   *
   * @type {string | null}
   * @memberof LeadPost
   */
  externalId?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof LeadPost
   */
  firstName?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof LeadPost
   */
  industry?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof LeadPost
   */
  jobTitle?: string | null;
  /**
   * 2-letter country code
   * @type {string | null}
   * @memberof LeadPost
   */
  lang?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof LeadPost
   */
  lastName?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof LeadPost
   */
  leadCompanyId?: string | null;
  /**
   *
   * @type {number | null}
   * @memberof LeadPost
   */
  leadScore?: number | null;
  /**
   * Optionally pass a single phone_number
   * @type {string}
   * @memberof LeadPost
   */
  phoneNumber?: string;
  /**
   * List of phone details
   * @type {Array<PhoneDetails>}
   * @memberof LeadPost
   */
  phones?: Array<PhoneDetails>;
  /**
   *
   * @type {string | null}
   * @memberof LeadPost
   */
  preferredMedium?: string | null;
  /**
   *
   * @type {string | null}
   * @memberof LeadPost
   */
  role?: string | null;
  /**
   *
   * @type {Array<any>}
   * @memberof LeadPost
   */
  tags?: Array<any>;
  /**
   * e.g. 'US/Pacific', 'UTC', etc
   * @type {string | null}
   * @memberof LeadPost
   */
  timezone?: string | null;
}

/**
 * Check if a given object implements the LeadPost interface.
 */
export function instanceOfLeadPost(value: object): value is LeadPost {
  return true;
}

export function LeadPostFromJSON(json: any): LeadPost {
  return LeadPostFromJSONTyped(json, false);
}

export function LeadPostFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LeadPost {
  if (json == null) {
    return json;
  }
  return {
    addresses:
      json['addresses'] == null
        ? undefined
        : (json['addresses'] as Array<any>).map(AddressFromJSON),
    campaignId: json['campaign_id'] == null ? undefined : json['campaign_id'],
    custom: json['custom'] == null ? undefined : json['custom'],
    department: json['department'] == null ? undefined : json['department'],
    emails:
      json['emails'] == null
        ? undefined
        : (json['emails'] as Array<any>).map(EmailDetailsFromJSON),
    engagementScore:
      json['engagement_score'] == null ? undefined : json['engagement_score'],
    externalId: json['external_id'] == null ? undefined : json['external_id'],
    firstName: json['first_name'] == null ? undefined : json['first_name'],
    industry: json['industry'] == null ? undefined : json['industry'],
    jobTitle: json['job_title'] == null ? undefined : json['job_title'],
    lang: json['lang'] == null ? undefined : json['lang'],
    lastName: json['last_name'] == null ? undefined : json['last_name'],
    leadCompanyId:
      json['lead_company_id'] == null ? undefined : json['lead_company_id'],
    leadScore: json['lead_score'] == null ? undefined : json['lead_score'],
    phoneNumber:
      json['phone_number'] == null ? undefined : json['phone_number'],
    phones:
      json['phones'] == null
        ? undefined
        : (json['phones'] as Array<any>).map(PhoneDetailsFromJSON),
    preferredMedium:
      json['preferred_medium'] == null ? undefined : json['preferred_medium'],
    role: json['role'] == null ? undefined : json['role'],
    tags: json['tags'] == null ? undefined : json['tags'],
    timezone: json['timezone'] == null ? undefined : json['timezone'],
  };
}

export function LeadPostToJSON(value?: LeadPost | null): any {
  if (value == null) {
    return value;
  }
  return {
    addresses:
      value['addresses'] == null
        ? undefined
        : (value['addresses'] as Array<any>).map(AddressToJSON),
    campaign_id: value['campaignId'],
    custom: value['custom'],
    department: value['department'],
    emails:
      value['emails'] == null
        ? undefined
        : (value['emails'] as Array<any>).map(EmailDetailsToJSON),
    engagement_score: value['engagementScore'],
    external_id: value['externalId'],
    first_name: value['firstName'],
    industry: value['industry'],
    job_title: value['jobTitle'],
    lang: value['lang'],
    last_name: value['lastName'],
    lead_company_id: value['leadCompanyId'],
    lead_score: value['leadScore'],
    phone_number: value['phoneNumber'],
    phones:
      value['phones'] == null
        ? undefined
        : (value['phones'] as Array<any>).map(PhoneDetailsToJSON),
    preferred_medium: value['preferredMedium'],
    role: value['role'],
    tags: value['tags'],
    timezone: value['timezone'],
  };
}
